import React  from 'react'
import moment from 'moment'
import { InputField } from './PrintFormComponents'

export default ({ name, form }) => {
    let initialValue = form.valueGetter(name)
    if (initialValue !== null && initialValue !== undefined && initialValue !== '' && moment(initialValue) !== 'Invalid Date') {
        initialValue = moment(initialValue).format('DD.MM.YYYY')
    } else {
        initialValue = null
    }

    const handleChange = (e) => {
        const value = moment(e.target.value).format('YYYY-MM-DD')
        form.onChange(name, { value })
    }

    return <InputField rows="1" id={name} defaultValue={initialValue} onChange={handleChange}/>
}



// WEBPACK FOOTER //
// ./src/components/printForm/PrintFormDateField.js